import { ApiTagsEnum }                                                         from "src/constants/api-tags";
import { ENDPOINTS }                                                           from "src/constants/api/api";
import { api }                                                                 from "src/store/services/api";
import type { IAdminReportsResponse }                                          from "src/store/services/reports/interfaces/admin-responses.interface";
import type { IGetReportsRequest, TimeTrackingRequest }                        from "src/store/services/reports/interfaces/requests.interface";
import type { IGetReportsResponse, TimeTrackingResponse }                      from "src/store/services/reports/interfaces/responses.interface";
import type { LazyListResponse }                                               from "src/store/services/utils/lazy-pagination";

const mapReportRequestParams = (request: IGetReportsRequest) => {
  const { date, devId, limit, offset, pageFrom, pageTo, perPage, project } = request;

  return {
    date    : date?.join(","),
    dev_id  : devId,
    project,
    limit,
    offset,
    pageFrom,
    pageTo,
    per_page: perPage,
  };
};

export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReports: build.query<LazyListResponse<IGetReportsResponse>, IGetReportsRequest>({
      query: (request: IGetReportsRequest) => ({
        url   : ENDPOINTS.REPORTS.GET_REPORTS,
        method: "GET",
        params: mapReportRequestParams(request),
      }),
      providesTags: [ApiTagsEnum.REPORTS],
    }),
    getAdminReports: build.query<IAdminReportsResponse, IGetReportsRequest>({
      query: (request: IGetReportsRequest) => ({
        url   : ENDPOINTS.ADMIN.REPORTS.LIST,
        method: "GET",
        params: mapReportRequestParams(request),
      }),
      providesTags: [ApiTagsEnum.REPORTS],
    }),
    deleteAdminReport: build.mutation<void, string>({
      query: (reportId: string) => ({
        url   : `${ENDPOINTS.ADMIN.REPORTS.LIST}/${reportId}`,
        method: "DELETE",
      }),
      invalidatesTags: [ApiTagsEnum.REPORTS],
    }),
    getReportsByUser: build.query<IGetReportsResponse[], string>({
      query: (developerId: string) => ({
        url   : `${ENDPOINTS.REPORTS.GET_DEVELOPER_REPORTS}/${developerId}`,
        method: "GET",
      }),
    }),
    getTimeTracking: build.query<TimeTrackingResponse[], TimeTrackingRequest>({
      query: (request: TimeTrackingRequest) => ({
        url   : ENDPOINTS.REPORTS.TIME_TRACKING,
        method: "POST",
        body  : request,
      }),
    }),
  }),
});

export const { useDeleteAdminReportMutation,
  useGetAdminReportsQuery,
  useGetReportsByUserQuery,
  useGetReportsQuery,
  useGetTimeTrackingQuery, } = reportsApi;
